/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-expressions */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable guard-for-in */
/* eslint-disable prettier/prettier */
/** @jsxImportSource @emotion/react */
import { useState, useEffect, useRef } from 'react';
import { Row } from '../Utils';
import { Input, Select, ForwardedSelect } from '../customFields';
import { isValidPhoneNumber, zip, required } from '../customFields/validations';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectState,
  selectDisableAutoComplete,
} from '../../../autoshipState/selectors';
import axios from 'axios';
import { useMediaQuery, useTheme } from '@mui/material';
import getAppState from 'app-state';
import {
  setCityDropdown,
  setCartShipViaOptions,
  setCartShipVia,
  setDisableAutoComplete,
} from '../../../autoshipState/autoshipSlice';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import t from '@rcm/i18n-client';
import getShipViaOptions from 'cart-ui-react/src/service/getShipViaOptions';
import getOrderAutoShipCodeFromOrder from 'cart-ui-react/src/service/getOrderAutoShipCodeFromOrder';

/**
 * Reusable address info form. Intended for use within react-final-form
 */
interface Props {
  addressType: 'shipping' | 'cartShipping' | 'billing' | 'cartBilling';
  customEvent?: boolean;
  setCustomEvent?: any;
  setAutocompleteValues: any;
  lookupCities?: boolean;
}

const AddressBlock = ({
  addressType,
  setCustomEvent = null,
  setAutocompleteValues,
  lookupCities = false,
  customEvent = false,
}: Props) => {
  const cartState: StateData<Cart> = useSelector(selectState);
  const [value, setValue] = useState(null);
  const [address, setAddress]: any = useState({});
  const [stateCodes, setStateCodes] = useState([]);
  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);
  const ref = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);
  const zipField = ref?.current?.childNodes[0]?.childNodes[1]?.value ?? null;
  // const addressLine1Field = ref3?.current ?? null;
  const siteIso3Code = getAppState('site.countryIso3');
  const isUS = siteIso3Code === 'USA';
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const disableAutoComplete = useSelector(selectDisableAutoComplete);
  const googlePlaceholder = {
    shipping: cartState.shippingAddress?.addressLine1,
    cartShipping: cartState.shipping?.data?.shipAddress?.addressLine1,
    billing: cartState.billingInfo?.billingAddress?.addressLine1,
    cartBilling: cartState.billAddress?.addressLine1,
  }[addressType];

  const setNewValue = (e) => {
    setValue(e);
  };

  const handleGoogleFailure = (error) => {
    setDisableAutoComplete(true);
    console.error('Could not inject Google script', error);
  };

  useEffect(() => {
    setAddress(cartState?.shippingAddress);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartState]);

  useEffect(() => {
    if (!disableAutoComplete) {
      // eslint-disable-next-line max-len
      axios
        .get(
          'api/v2/get-rcm-config/disableGoogleAutoCompleteOnCartV2?context=' +
            siteIso3Code
        )
        .then(function (response) {
          dispatch(
            setDisableAutoComplete(
              response.data?.value === 'true' || response.data?.value === true
            )
          );
        });
    }
  }, []);

  useEffect(() => {
    setAutocompleteValues(value);
  }, [value]);

  useEffect(() => {
    const controller = new AbortController();
    if (
      cartState?.shippingAddress?.country ||
      cartState?.shipping?.data?.shipAddress?.country
    ) {
      // get states for selected country
      axios
        .get('/api/resource/country-rules/' + siteIso3Code, {
          signal: controller.signal,
        })
        .then(function (response) {
          // convert to arrays so that we can map the values
          const allStates = Object.entries(response.data.allowedStates);
          const allCountries = Object.entries(response.data.allowedCountries);
          setStateCodes(allStates);
          setCountries(allCountries);
          setCustomEvent ? setCustomEvent(true) : null;
        })
        .catch((err) => {
          if (err.code !== 'ERR_CANCELED') {
            throw new Error(err.message);
          }
          return;
        });
    }
    return () => controller.abort();
  }, [address]);

  // please don't judge us for this
  useEffect(() => {
    const controller = new AbortController();
    // get cities related to Postal Code
    const apiCities = [];
    if (
      zipField?.trim().length >= 5 &&
      isUS &&
      zipField != localStorage.getItem('prevZip')
    ) {
      setCities([]);
      axios
        .get(
          '/api/resource/geo-code?filter%5Bwhere%5D%5Bzip%5D=' +
            zipField.trim().substring(0, 5),
          {
            signal: controller.signal,
          }
        )
        .then(function (response) {
          response.data.forEach((el) => {
            apiCities.push([el['city'], el['label'], el['geoCode']]);
          });
          setCities(apiCities);
          ref2.current.setSelected(apiCities[0][0]);
          dispatch(setCityDropdown(apiCities));
        })
        .catch((err) => {
          if (err.code !== 'ERR_CANCELED') {
            throw new Error(err.message);
          }
          return;
        });
    }
    localStorage.setItem('prevZip', zipField);
    return () => controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lookupCities, zipField, address]);

  useEffect(() => {
    if (cartState && address && addressType === 'cartShipping') {
      const shipViaAddress = cartState.shipping.data.shipAddress;
      getShipViaOptions(
        cartState.items.map((orderItem) => {
          return {
            itemCode: orderItem.skuNumber,
            quantity: orderItem.quantity,
          };
        }),
        shipViaAddress.country,
        shipViaAddress.postalCode,
        shipViaAddress.city,
        shipViaAddress.state,
        cartState.attributes.currentUserRules.profile.status,
        getOrderAutoShipCodeFromOrder(cartState),
        cartState.userId
      ).then(function (viaOptions: any) {
        const optionExists = !!viaOptions.find(
          (option) =>
            option.value.toString() ===
            cartState.shipping.data.shipVia.toString()
        );
        if (
          viaOptions.length === 1 ||
          (!optionExists && viaOptions.length > 0)
        ) {
          // If there is only one via option, automatically select it,
          // Also if the option we had selected before doesn't exist, select the first option
          dispatch(setCartShipVia(viaOptions[0].value));
          localStorage.setItem(
            'userSetShipVia',
            viaOptions[0].value.toString()
          );
        }
        dispatch(setCartShipViaOptions(viaOptions));
      });
    }
  }, [zipField, address]);

  return (
    <div
      css={{
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
        gap: '5%',
      }}
    >
      <div css={{ fontSize: '13px', fontWeight: '400' }}>
        * - required fields
      </div>
      {addressType === 'cartShipping' && (
        <Row
          sx={{ maxHeight: '65px', justifyContent: 'space-between', gap: '2%' }}
        >
          <Input label={t('Name') + ' *'} name='nameLine' required />
          <Input
            label={t('Phone Number') + ' *'}
            validate={isValidPhoneNumber}
            name='phone'
            required
          />
        </Row>
      )}
      <div css={{ width: '100%', maxHeight: '76px' }}>
        {disableAutoComplete ? (
          <Input
            label={t('Address Line 1') + ' *'}
            name='addressLine1'
            required
          />
        ) : (
          <div ref={ref3}>
            <div css={{ fontSize: '16px', margin: '8px 0px 4px 0px' }}>
              {t('Address Line 1')} *
            </div>
            <GooglePlacesAutocomplete
              apiKey='AIzaSyBFMUdGn-Mtfo7NXPesMGU6L8ZtjiaKAhw'
              minLengthAutocomplete={1}
              onLoadFailed={(error) => handleGoogleFailure(error)}
              selectProps={{
                placeholder: googlePlaceholder,
                label: t('Address Line 1'),
                autoFocus: true,
                defaultMenuIsOpen: false,
                value: value,
                onChange: setNewValue,
              }}
            />
          </div>
        )}
      </div>
      <Row sx={{ maxHeight: '65px' }}>
        <Input label={t('Address Line 2')} name='addressLine2' />
      </Row>

      {addressType === 'shipping' || addressType === 'cartShipping' ? (
        // shipping address UI
        <div>
          <Row
            sx={{
              maxHeight: '76px',
              gap: '1.5%',
              justifyContent: 'space-between',
            }}
          >
            <div ref={ref}>
              <Input
                label={t('Postal Code') + ' *'}
                name='postalCode'
                required
                validate={isUS ? zip : required}
              />
            </div>
            {isUS ? (
              <ForwardedSelect
                label={t('City') + ' *'}
                ref={ref2}
                name='city'
                options={[
                  ...cities.map((i) => ({
                    option: i[1],
                    value: i[0],
                    geoCode: i[2],
                  })),
                ]}
                required
              />
            ) : (
              <Input label={t('City') + ' *'} name='city' required />
            )}
          </Row>
          <Row
            sx={{
              marginBottom: '8px',
              maxHeight: '76px',
              justifyContent: 'space-between',
              gap: '2%',
            }}
          >
            {stateCodes.length ? (
              <Select
                label={t('State') + ' *'}
                name='state'
                options={[
                  ...stateCodes.map((i) => ({ option: i[1], value: i[0] })),
                ]}
                required
              />
            ) : null}

            {countries.length ? (
              <Select
                label={t('Country') + ' *'}
                name='country'
                options={[
                  ...countries.map((i) => ({ option: t(i[1]), value: i[0] })),
                ]}
                required
              />
            ) : null}
          </Row>
        </div>
      ) : (
        // billing address UI
        <>
          {isMobile ? (
            <>
              <Row sx={{ gap: '1.5%' }}>
                <Input label={t('City') + ' *'} name='city' required />
              </Row>
              <Row sx={{ gap: '1.5%' }}>
                <Input
                  label={t('Postal Code') + ' *'}
                  name='postalCode'
                  required
                  validate={isUS ? zip : required}
                />
                {stateCodes.length ? (
                  <Input label={t('State') + ' *'} name='state' required />
                ) : null}
                {addressType === 'cartBilling' ? (
                  <Input label={t('Country') + ' *'} name='country' required />
                ) : null}
              </Row>
            </>
          ) : (
            <Row sx={{ maxHeight: '76px', gap: '1.5%' }}>
              <Input label={t('City') + ' *'} name='city' required />
              <Input
                label={t('Postal Code') + ' *'}
                name='postalCode'
                required
                validate={isUS ? zip : required}
              />
              {stateCodes.length ? (
                <Input label={t('State') + ' *'} name='state' required />
              ) : null}
              <Select
                label={t('Country') + ' *'}
                name='country'
                options={[
                  ...countries.map((i) => ({ option: t(i[1]), value: i[0] })),
                ]}
                required
              />
            </Row>
          )}
        </>
      )}
    </div>
  );
};

export default AddressBlock;
